import { getLocalizedAttrValue, getLocalizedString } from '@grandvisionhq/utils';

const mapBundleChildLineItems = (lineItem, intl)=>{
    return lineItem.bundleLineItems.map((child)=>toBundleChildLineItem(intl)(child)
    );
};
const toBundleChildLineItem = (intl)=>{
    return (child)=>{
        var ref, ref1;
        const lensColor = getLocalizedAttrValue(child.legacyProduct.masterData.current.variant, 'lensColor', intl.locale);
        const productName = getLocalizedString(child.legacyProduct.masterData.current.name, intl.locale);
        const body = lensColor && !child.isMainBundleLineItem ? `${productName} - ${lensColor}` : productName;
        // The main bundle line item can be a frame of regular glasses or sunglasses, in both cases we render a frame label
        const title = child.isMainBundleLineItem ? intl.getLabel('cart.lineItem.glasses.bundleItem.frame') : intl.getLabel(`cart.lineItem.glasses.bundleItem.${child.legacyProduct.productType}`);
        return {
            title,
            body,
            type: child.legacyProduct.productType,
            originalPrice: (ref = child.price) === null || ref === void 0 ? void 0 : ref.total.subtotal,
            price: ((ref1 = child.price) === null || ref1 === void 0 ? void 0 : ref1.total.gross) || 0,
            sku: child.sku
        };
    };
};

export { mapBundleChildLineItems, toBundleChildLineItem };
//# sourceMappingURL=map-bundle-child-line-items.js.map
